export function Export(organizationID: number): string {
	return `/v1/organizations/${organizationID}/views/payouts-reports/export`;
}

export function Index(organizationID: number): string {
	return `/v1/organizations/${organizationID}/views/payouts-reports`;
}

